const cellHasValue = (cell) => {
  if (!cell || cell.v == null || cell.v === "") {
    return false;
  }
  return String(cell.v).trim() !== "";
};

export const sheetHasData = (worksheet) => {
  if (!worksheet) {
    return false;
  }

  return Object.keys(worksheet).some((key) => {
    if (key.charAt(0) === "!") {
      return false;
    }
    return cellHasValue(worksheet[key]);
  });
};

export const listSheetsWithData = (workbook) => {
  const names = workbook?.SheetNames || [];
  return names
    .map((name, index) => ({ id: index, name }))
    .filter((sheet) => sheetHasData(workbook.Sheets?.[sheet.name]));
};
